export type InviteRegistrationRequest = {
    deviceId?: string,
    inviteId: string,
    latitude?: string,
    longitude?: string,
    userEmail: string,
    userFullName: string,
    userPassword: string,
    userWorkspaceId: number
}

export const InviteRegistrationRequestInit: InviteRegistrationRequest = {
    deviceId: "",
    inviteId: "",
    latitude: "",
    longitude: "",
    userEmail: "",
    userFullName: "",
    userPassword: "",
    userWorkspaceId: 0
}